"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchQueryToUrl = exports.buildGeoString = exports.buildFeatures = exports.buildBed = exports.buildSize = exports.buildPrice = exports.featuresMap = exports.sortMap = exports.sizetypeRevMap = exports.sizetypeMap = void 0;
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var SfilterSizeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterSizeGroup");
var maputil_1 = require("@/transformers/maputil");
var SfilterLayoutGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterLayoutGroup.init");
var IconType_1 = require("@/pages/search/states/IconType");
var GetSuggestionApiResponse_1 = require("@/pages/search/states/GetSuggestionApiResponse");
var langMap = {
    0: 'en',
    1: 'en',
    2: 'zh-hk',
    3: 'zh-cn',
};
exports.sizetypeMap = {
    G: 'gross',
    S: 'saleable',
};
exports.sizetypeRevMap = {
    G: SfilterSizeGroup_1.SfilterSizeType.GROSS,
    S: SfilterSizeGroup_1.SfilterSizeType.SALEABLE,
};
var noBed = 'studio';
var aboveName = 'above';
var belowName = 'below';
exports.sortMap = {
    price: 'price',
    netsize: 'saleablesize',
    grosssize: 'grosssize',
    district: 'localityname',
    name: 'name',
    lastupdateddate: 'updateddate',
    updateddate: 'updateddate',
    qualityscore: 'qualityscore',
    pricepersqft: 'pricepersqft',
};
var orderbyMap = {
    asc: 'asc',
    desc: 'desc',
};
exports.featuresMap = {
    hasMaidRoom: 'maidroom',
    hasParking: 'carpark',
    hasOutdoorSpace: 'outdoorspace',
};
var sizeUnit = 'ft';
var buildLanguage = function (langId) {
    return langMap[langId] || '';
};
var buildIsMap = function (isMap) {
    return isMap ? 'map' : '';
};
var buildType = function (typeId) {
    return SfilterTypeGroup_1.ListingPurposeType.toString(typeId) || '';
};
var buildExclusive = function (iconType) {
    return iconType === IconType_1.IconType.Exclusive ? 'exclusive' : '';
};
var buildLayoutSlug = function (layoutId, languageId) {
    var _a;
    // languageId mapping (see langMap above):
    // 2 = zh-hk, 3 = zh-cn, others = english slugs
    if (languageId === 2) {
        switch (layoutId) {
            case 1: return '住宅';
            case 2: return '複式';
            case 3: return '三層複式';
            case 4: return '閣樓';
            case 5: return '獨立屋';
            case 7: return '開放式';
            case 17: return '村屋';
        }
    }
    if (languageId === 3) {
        switch (layoutId) {
            case 1: return '住宅';
            case 2: return '复式';
            case 3: return '三层复式';
            case 4: return '阁楼';
            case 5: return '独立屋';
            case 7: return '开放式';
            case 17: return '村屋';
        }
    }
    // English (default)
    var layoutOptions = SfilterLayoutGroup_init_1.defaultSfilterLayoutGroupState.options;
    return ((_a = layoutOptions.find(function (it) { return it.id === layoutId; })) === null || _a === void 0 ? void 0 : _a.key) || '';
};
var buildLayout = function (layout, languageId) {
    if (!layout || !layout.trim())
        return '';
    var ids = layout
        .split(',')
        .map(function (it) { return Number(it.trim()); })
        .filter(function (it) { return !Number.isNaN(it) && it > 0; });
    var slugs = ids
        .map(function (id) { return buildLayoutSlug(id, languageId); })
        .filter(function (it) { return it; });
    if (!slugs.length)
        return '';
    return __spreadArrays(['property'], slugs).join('-');
};
var buildDistrict = function (aIds, dIds, districtName) {
    if (districtName)
        return districtName;
    if (!aIds && !dIds)
        return '';
    return __spreadArrays([
        'localityarea'
    ], aIds.split(',').map(function (aid) { return "a" + aid; }), dIds.split(',').map(function (did) { return "d" + did; })).join('-');
};
exports.buildPrice = function (min, max, currencyKey) {
    if (min === 0 && max === 0)
        return '';
    var newMin = min;
    var newMax = max;
    var range = [];
    if (newMin === 0) {
        range = [belowName, newMax.toString()];
    }
    else if (newMax === 0 || newMax === -1) {
        range = [aboveName, newMin.toString()];
    }
    else {
        range = [newMin.toString(), newMax.toString()];
    }
    return __spreadArrays(['price'], range, [SfilterPriceGroup_1.currencyMap[currencyKey]]).join('-');
};
exports.buildSize = function (min, max, type) {
    if (min === 0 && max === 0)
        return '';
    var range = [min.toString(), max.toString()];
    if (min === 0)
        range = [belowName, max.toString()];
    if (max === 0 || max === -1)
        range = [aboveName, min.toString()];
    return __spreadArrays(['size', exports.sizetypeMap[type]], range, [sizeUnit]).join('-');
};
exports.buildBed = function (min, max) {
    if (min === 0 && max === 20)
        return '';
    var range = [];
    if (min === 0 && max === 0)
        range = [noBed];
    if (min !== 0)
        range = ["" + aboveName, min.toString()];
    return __spreadArrays(range, ['beds']).join('-');
};
exports.buildFeatures = function (query) {
    var features = [];
    for (var key in query) {
        if (!exports.featuresMap[key])
            continue;
        features.push(exports.featuresMap[key]);
    }
    if (!features.length)
        return '';
    return __spreadArrays(['features'], features).join('-');
};
exports.buildGeoString = function (geoString) {
    if (!geoString)
        return '';
    var _a = maputil_1.parseGeoString(geoString), ne = _a.ne, sw = _a.sw;
    return ['rect', ne.lat + "~" + ne.lng + "_" + sw.lat + "~" + sw.lng].join('-');
};
var buildZoomLevel = function (zoom) {
    if (!zoom)
        return '';
    return ['zm', zoom].join('-');
};
var buildExpandMetre = function (isMap) {
    return isMap ? ['em', 1].join('-') : '';
};
var buildSearchResultTypeKeyword = function (searchResultType, searchResultId, keyword) {
    if (searchResultType === GetSuggestionApiResponse_1.GetSuggestionResultType.Building || searchResultType === GetSuggestionApiResponse_1.GetSuggestionResultType.Block) {
        if (searchResultType === GetSuggestionApiResponse_1.GetSuggestionResultType.Building) {
            // Include building ID in URL to avoid name lookup ambiguity
            if (searchResultId && searchResultId > 0) {
                return ['building', keyword, searchResultId.toString()].join('/');
            }
            return ['building', keyword].join('/');
        }
        // Include building block ID in URL if available
        if (searchResultId && searchResultId > 0) {
            return ['building/block', keyword, searchResultId.toString()].join('/');
        }
        return ['building/block', keyword].join('/');
    }
    if (!keyword)
        return '';
    return [keyword, 'keyword'].join('-');
};
var buildSortby = function (sortBy) {
    if (sortBy === 'qualityscore')
        return '';
    return ['sortby', exports.sortMap[sortBy]].join('-');
};
var buildOrderby = function (orderBy) {
    if (orderBy.toLowerCase() === 'desc')
        return '';
    return ['orderby', orderbyMap[orderBy.toLowerCase()]].join('-');
};
var buildPage = function (page) {
    if (page < 2)
        return '';
    return ['page', page].join('-');
};
exports.searchQueryToUrl = function (searchQuery) {
    if (!searchQuery)
        return null;
    var newQuery = '';
    var priceMin = SfilterTypeGroup_1.ListingPurposeType.Sale === searchQuery.listingTypeId ? searchQuery.priceMin * 10000 : searchQuery.priceMin;
    var priceMax = SfilterTypeGroup_1.ListingPurposeType.Sale === searchQuery.listingTypeId ? searchQuery.priceMax * 10000 : searchQuery.priceMax;
    newQuery = [
        buildLanguage(searchQuery.languageId),
        'property-search',
        buildIsMap(searchQuery.isMap),
        buildType(searchQuery.listingTypeId),
        buildExclusive(searchQuery.iconType),
        buildDistrict(searchQuery.area, searchQuery.district, searchQuery.districtName),
        buildSearchResultTypeKeyword(searchQuery.searchResultType, searchQuery.searchResultId, searchQuery.keyword),
        buildLayout(searchQuery.layout, searchQuery.languageId),
        exports.buildPrice(priceMin, priceMax, searchQuery.currencyId),
        exports.buildSize(searchQuery.sizeMin, searchQuery.sizeMax, searchQuery.sizeType),
        exports.buildBed(searchQuery.bedroomMin, searchQuery.bedroomMax),
        exports.buildFeatures(searchQuery),
        exports.buildGeoString(searchQuery.geoString),
        buildZoomLevel(searchQuery.zoomLevel),
        buildExpandMetre(searchQuery.isMap),
        buildSortby(searchQuery.sortBy),
        buildOrderby(searchQuery.orderBy),
        buildPage(searchQuery.pageNumber),
    ]
        .filter(function (it) { return it; })
        .join('/');
    return "/" + newQuery;
};
